 
import colors from 'vuetify/lib/util/colors'

export default {
  primary: {
    base: '#185EA9',
    darken1: colors.purple.darken2,
  },
  success: {
      base: '#4caf50',
      darken1: colors.purple.darken2,
  },
  worktimesecondary: '#B9CADD', 
  anchor: '#185EA9', 
  worktimetitle: '#185EA9',
  light: '#FEFEFE'
}